// extracted by mini-css-extract-plugin
export default {"button":"TypeSelectButton__button--1DcQz","selected":"TypeSelectButton__selected--1_YnZ","icon":"TypeSelectButton__icon--L4aS1"};